module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process !== 'next_actions') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body portlet-overflow"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createRegion($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newRegion.region_name),
      expression: "newRegion.region_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRegion.region_name.length
    },
    attrs: {
      "type": "text",
      "id": "create_region_name"
    },
    domProps: {
      "value": (_vm.newRegion.region_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRegion, "region_name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_region_name"
    }
  }, [_vm._v("Region Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v("Return To Regions Dashboard")]), _vm._v(" "), _c('button', {
    key: "create-location-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit ")])])]) : _vm._e()])], 1)])]) : _c('next-actions', {
    attrs: {
      "actionsList": _vm.createRegionNextActions
    },
    on: {
      "runFunction": _vm.runFunction
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\tCreate A Region\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61062b5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Regions/CreateRegion.vue
// module id = 435
// module chunks = 1